// export const translateSport = {
//     "Corrida": "running",
//     "Natação": "swimming",
//     "Bicicleta": "bike",
//     "BFR": "running",
//     "Trail": "running",
//     "Nordic Walking": "running",
//     "Máquinas indoor": "indoor"
// }

export const translateSport = (sport) => {
	switch (sport) {
		case 'Corrida':
			return 'running'
		case 'Natação':
			return 'swimming'
		case 'Bicicleta':
			return 'bike'
		case 'BFR':
			return 'running'
		case 'Trail':
			return 'running'
		case 'Nordic Walking':
			return 'running'
		case 'Máquinas indoor':
			return 'indoor'
		default:
			break
	}
}

export const translateGround = (ground) => {
	switch (ground) {
		case 'Estrada':
			return 'estrada'
		case 'Montanha':
			return 'mountain'
		case 'Piscina':
			return 'pool'
		case 'Misto':
			return 'mixed'
		case 'Montanha W+':
			return 'mountain'
		default:
			break
	}
}

export const translateType = (type) => {
	switch (type) {
		case 'Normal':
			return 'Normal'
		case 'Cumulate':
			return 'Acumulada'
		case 'Bidaily':
			return 'Bidiária'
		default:
			break
	}
}

export const translateMonth = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export function calculateEquivalentDistance(distance, DP, DN) {
	distance += 0.00000012 * Math.pow(DP, 2) + 0.00572 * DP
	distance += 0.00000012 * Math.pow(DN, 2) + 0.0005 * DN
	return Math.round(distance * 100) / 100
}

export function calculateCalories(distance, athlete, goal) {
	const { currentWeight, biometricData } = athlete
	const pesoAtleta = parseInt(currentWeight.currentWeight, 10) || 0
	let pesoEquipamento = 0
	if (goal.name === 'LD') {
		if (biometricData.gender === 'male') {
			pesoEquipamento = 2.0
		} else {
			pesoEquipamento = 1.5
		}
	}
	return Math.floor((pesoEquipamento + pesoAtleta) * distance * 1.036)
}



// WEBPACK FOOTER //
// ./src/client/webapp/helpers/helpers.js